import {ProductState} from '../../shared/DTO/productState';
import {Management} from '../../shared/DTO/management';
import {ContactModel} from './contact.model';
import {IdentityModel} from './identity.model';
import {ProductTypeModel} from './product-type.model';
import {BasicProductModel} from './basic-product.model';
import {BaseModel} from '../../base/models/base-model.model';
import {BasicProperty1Model} from './basic-property1.model';
import * as moment from 'moment';

export class ProductModel extends BaseModel {
  private _activationDate?: moment.Moment;
  private _certifiedEmail?: string;
  private _description?: string;
  private _duration?: string;
  private _expirationDate?: moment.Moment;
  private _identity?: IdentityModel;
  private _productType?: ProductTypeModel;
  private _state?: ProductState;
  private _unit?: string;
  private _userId?: string;
  private _accountCode?: string;
  private _alias?: string;
  private _contacts?: Array<ContactModel>;
  private _customerCode?: string;
  private _invoiceExpirationDate?: moment.Moment;
  private _management?: Management;
  private _massive?: boolean;
  private _orderId?: number;
  private _properties: Array<BasicProperty1Model>;
  private _subProducts?: Array<BasicProductModel>;
  private _urlRedirect?: string;

  constructor(activationDate?: moment.Moment, certifiedEmail?: string, description?: string, duration?: string, expirationDate?: moment.Moment, identity?: IdentityModel, productType?: ProductTypeModel, state?: ProductState, unit?: string, userId?: string, accountCode?: string, alias?: string, contacts?: Array<ContactModel>, customerCode?: string, invoiceExpirationDate?: moment.Moment, management?: Management, massive?: boolean, orderId?: number, properties?: Array<BasicProperty1Model>, subProducts?: Array<BasicProductModel>, urlRedirect?: string) {
    super();
    this._activationDate = activationDate;
    this._certifiedEmail = certifiedEmail;
    this._description = description;
    this._duration = duration;
    this._expirationDate = expirationDate;
    this._identity = identity;
    this._productType = productType;
    this._state = state;
    this._unit = unit;
    this._userId = userId;
    this._accountCode = accountCode;
    this._alias = alias;
    this._contacts = contacts;
    this._customerCode = customerCode;
    this._invoiceExpirationDate = invoiceExpirationDate;
    this._management = management;
    this._massive = massive;
    this._orderId = orderId;
    this._properties = properties;
    this._subProducts = subProducts;
    this._urlRedirect = urlRedirect;
  }

  get properties(): Array<BasicProperty1Model> {
    return this._properties;
  }

  set properties(value: Array<BasicProperty1Model>) {
    this._properties = value;
  }

  get activationDate(): moment.Moment {
    return this._activationDate;
  }

  set activationDate(value: moment.Moment) {
    this._activationDate = value;
  }

  get certifiedEmail(): string {
    return this._certifiedEmail;
  }

  set certifiedEmail(value: string) {
    this._certifiedEmail = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get duration(): string {
    return this._duration;
  }

  set duration(value: string) {
    this._duration = value;
  }

  get expirationDate(): moment.Moment {
    return this._expirationDate;
  }

  set expirationDate(value: moment.Moment) {
    this._expirationDate = value;
  }

  get identity(): IdentityModel {
    return this._identity;
  }

  set identity(value: IdentityModel) {
    this._identity = value;
  }

  get productType(): ProductTypeModel {
    return this._productType;
  }

  set productType(value: ProductTypeModel) {
    this._productType = value;
  }

  get state(): ProductState {
    return this._state;
  }

  set state(value: ProductState) {
    this._state = value;
  }

  get unit(): string {
    return this._unit;
  }

  set unit(value: string) {
    this._unit = value;
  }

  get userId(): string {
    return this._userId;
  }

  set userId(value: string) {
    this._userId = value;
  }

  get accountCode(): string {
    return this._accountCode;
  }

  set accountCode(value: string) {
    this._accountCode = value;
  }

  get alias(): string {
    return this._alias;
  }

  set alias(value: string) {
    this._alias = value;
  }

  get contacts(): Array<ContactModel> {
    return this._contacts;
  }

  set contacts(value: Array<ContactModel>) {
    this._contacts = value;
  }

  get customerCode(): string {
    return this._customerCode;
  }

  set customerCode(value: string) {
    this._customerCode = value;
  }

  get invoiceExpirationDate(): moment.Moment {
    return this._invoiceExpirationDate;
  }

  set invoiceExpirationDate(value: moment.Moment) {
    this._invoiceExpirationDate = value;
  }

  get management(): Management {
    return this._management;
  }

  set management(value: Management) {
    this._management = value;
  }

  get massive(): boolean {
    return this._massive;
  }

  set massive(value: boolean) {
    this._massive = value;
  }

  get orderId(): number {
    return this._orderId;
  }

  set orderId(value: number) {
    this._orderId = value;
  }

  get subProducts(): Array<BasicProductModel> {
    return this._subProducts;
  }

  set subProducts(value: Array<BasicProductModel>) {
    this._subProducts = value;
  }

  get urlRedirect(): string {
    return this._urlRedirect;
  }

  set urlRedirect(value: string) {
    this._urlRedirect = value;
  }
}
